// AP Lookbook — hotspot popovers: one open at a time, Esc / outside-click close.
// Dot binding is idempotent + re-runs on shopify:section:load; the document-level
// outside-click / Esc listeners are bound once for the page (never stacked on reload).
(function () {
  var openDot = null;

  function popFor(dot) {
    var id = dot.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function close(dot) {
    if (!dot) return;
    var pop = popFor(dot);
    dot.setAttribute('aria-expanded', 'false');
    dot.classList.remove('is-active');
    if (pop) { pop.classList.remove('is-open'); pop.hidden = true; }
    if (openDot === dot) openDot = null;
  }

  function open(dot) {
    if (openDot && openDot !== dot) close(openDot);
    var pop = popFor(dot);
    dot.setAttribute('aria-expanded', 'true');
    dot.classList.add('is-active');
    if (pop) { pop.hidden = false; pop.classList.add('is-open'); }
    openDot = dot;
  }

  function bindDot(dot) {
    if (dot.dataset.apLb) return;
    dot.dataset.apLb = '1';
    dot.addEventListener('click', function (e) {
      e.stopPropagation();
      if (openDot === dot) { close(dot); } else { open(dot); }
    });
  }

  function boot() {
    document.querySelectorAll('.ap-lookbook .ap-lb__dot').forEach(bindDot);
  }

  // Outside-click closes (clicks inside a popover stay open).
  document.addEventListener('click', function (e) {
    if (!openDot) return;
    var pop = popFor(openDot);
    if (pop && pop.contains(e.target)) return;
    if (openDot.contains(e.target)) return;
    close(openDot);
  });

  // Esc closes and returns focus to the hotspot.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDot) {
      var d = openDot;
      close(d);
      d.focus();
    }
  });

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
